import { render, staticRenderFns } from "./Mustervorlagen.vue?vue&type=template&id=ef0c3548&scoped=true&"
import script from "./Mustervorlagen.vue?vue&type=script&lang=js&"
export * from "./Mustervorlagen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0c3548",
  null
  
)

export default component.exports